<template>
  <v-card elevation="3" class="mb-6 rounded-xl">
    <v-card-title
      class="d-flex align-center mb-2 pb-0 cursor-pointer"
      @click="mostrarReportesEspeciales = !mostrarReportesEspeciales"
    >
      <v-icon color="primary" class="mr-3">mdi-file-chart</v-icon>
      <span class="text-h6 font-weight-bold">Reportes Especiales</span>
      <v-spacer></v-spacer>
      <v-icon color="primary">
        {{ mostrarReportesEspeciales ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </v-card-title>

    <v-expand-transition>
      <div v-show="mostrarReportesEspeciales" class="pa-4 pt-0">
        <v-row align="center">
          <v-col cols="12" md="8">
            <v-select
              v-model="reporteEspecial"
              :items="tiposReportes"
              label="Seleccionar tipo de reporte"
              outlined
              dense
              clearable
              :disabled="loading || reporteGenerado"
              append-icon="mdi-chevron-down"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="reporteEspecial">
            <v-btn
              block
              color="primary"
              class="elevation-2"
              :disabled="loading || isExporting || reporteGenerado"
              :loading="loading || isExporting"
              @click="onGenerarReporteEspecial"
            >
              <v-icon left>mdi-file-chart</v-icon>
              Generar {{ reporteEspecial }}
            </v-btn>
          </v-col>
        </v-row>

        <!-- Información de fecha disponible para Info Cte y No Cte -->
        <v-row v-if="(reporteEspecial === 'Info Cte y No Cte' || reporteEspecial === 'Reporte de Saldos - HTC') && fechaDisponibleInfo" align="center" class="mt-2">
          <v-col cols="12">
            <v-alert
              color="info"
              icon="mdi-information"
              outlined
              dense
              class="mb-0"
            >
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="info">mdi-calendar-clock</v-icon>
                <span class="font-weight-medium">Período disponible: {{ fechaDisponibleInfo.description }}</span>
              </div>
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import reportesApiService from '@/utils/reportesApi';

export default {
  name: 'ReportSpecialSection',
  props: {
    tiposReportes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isExporting: {
      type: Boolean,
      default: false,
    },
    reporteGenerado: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['generar-reporte-especial', 'configure-special-filters'],
  data() {
    return {
      mostrarReportesEspeciales: true,
      reporteEspecial: null,
      fechaDisponibleInfo: null,
      loadingFechaDisponible: false,
    };
  },
  methods: {
    onGenerarReporteEspecial() {
      // Configure filters first if it's Info Mora (Financiamiento)
      if (this.reporteEspecial === 'Info Mora (Financiamiento)') {
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Mora (Financiamiento)',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado'],
            requiereFideicomisoUnico: true,
          },
        });
      }
      // Configure filters for Info Cobranzas Proyectadas
      if (this.reporteEspecial === 'Info Cobranzas Proyectadas') {
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Cobranzas Proyectadas',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado'],
            requiereFideicomisoUnico: true,
          },
        });
      }
      // Configure filters for Info Cobranzas
      if (this.reporteEspecial === 'Info Cobranzas') {
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Cobranzas',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado'],
            requiereFideicomisoUnico: true,
            deshabilitarSubtotales: true,
          },
        });
      }
      // Configure filters for Info Cte y No Cte
      if (this.reporteEspecial === 'Info Cte y No Cte') {
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Cte y No Cte',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado', 'Cancelado'],
            requiereFideicomisoUnico: true,
            ocultarRangoFechas: true,
            deshabilitarSubtotales: true,
          },
        });
      }
      // Configure filters for Reporte de Saldos - HTC
      if (this.reporteEspecial === 'Reporte de Saldos - HTC') {
        this.$emit('configure-special-filters', {
          tipoReporte: 'Reporte de Saldos - HTC',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado', 'Cancelado'],
            requiereFideicomisoUnico: true,
            ocultarRangoFechas: true,
            deshabilitarSubtotales: true,
          },
        });
      }
      // Then trigger the report generation
      this.$emit('generar-reporte-especial', this.reporteEspecial);
    },
    limpiarSeleccion() {
      this.reporteEspecial = null;
      this.fechaDisponibleInfo = null;
    },
    reset() {
      this.reporteEspecial = null;
      this.mostrarReportesEspeciales = true;
      this.fechaDisponibleInfo = null;
    },
    async obtenerFechaDisponible() {
      try {
        this.loadingFechaDisponible = true;
        const fechaInfo = await reportesApiService.obtenerFechasDisponiblesCteYNoCte();
        this.fechaDisponibleInfo = fechaInfo;
        console.log('📅 Fecha disponible obtenida:', fechaInfo);
      } catch (error) {
        console.error('Error al obtener fecha disponible:', error);
        this.fechaDisponibleInfo = null;
      } finally {
        this.loadingFechaDisponible = false;
      }
    },
  },
  watch: {
    reporteEspecial(newVal) {
      if (newVal === null) {
        // Si se deselecciona, limpiar las configuraciones especiales
        this.$emit('configure-special-filters', null);
        // Limpiar la información de fecha disponible
        this.fechaDisponibleInfo = null;
      } else if (newVal === 'Info Mora (Financiamiento)') {
        // Configurar automáticamente los filtros cuando se selecciona Info Mora
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Mora (Financiamiento)',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado'],
            requiereFideicomisoUnico: true,
            deshabilitarSubtotales: true,
          },
        });
      } else if (newVal === 'Info Cobranzas Proyectadas') {
        // Configurar automáticamente los filtros cuando se selecciona Info Cobranzas Proyectadas
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Cobranzas Proyectadas',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado'],
            requiereFideicomisoUnico: true,
            deshabilitarSubtotales: false,
          },
        });
      } else if (newVal === 'Info Cobranzas') {
        // Configurar automáticamente los filtros cuando se selecciona Info Cobranzas
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Cobranzas',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado'],
            requiereFideicomisoUnico: true,
            deshabilitarSubtotales: true,
          },
        });
      } else if (newVal === 'Info Cte y No Cte') {
        // Configurar automáticamente los filtros cuando se selecciona Info Cte y No Cte
        this.$emit('configure-special-filters', {
          tipoReporte: 'Info Cte y No Cte',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado', 'Cancelado'],
            requiereFideicomisoUnico: true,
            ocultarRangoFechas: true,
            deshabilitarSubtotales: true,
          },
        });
        // Obtener automáticamente la fecha disponible
        this.obtenerFechaDisponible();
      } else if (newVal === 'Reporte de Saldos - HTC') {
        // Configurar automáticamente los filtros cuando se selecciona Reporte de Saldos - HTC
        this.$emit('configure-special-filters', {
          tipoReporte: 'Reporte de Saldos - HTC',
          configuracion: {
            filtroTipoServicio: 'Financiamiento',
            estadosSolicitados: ['Otorgado', 'Cancelado'],
            requiereFideicomisoUnico: true,
            ocultarRangoFechas: true,
            deshabilitarSubtotales: true,
          },
        });
        // Obtener automáticamente la fecha disponible
        this.obtenerFechaDisponible();
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
